<template>
  <Login
    title="后台管理系统"
    copyright="escon 2020-2025"
    :logo="require('../../assets/logo.png')"
    :getCode="getCodeRe"
    :checkCode="checkCodeRe"
    @onLogin="handleLogin"
  />
</template>

<script setup name="">
import { ref, onMounted } from 'vue';
import Login from '@escon/login-ms';
import '@escon/login-ms/lib/index.css';
import { getCodeRe, checkCodeRe, loginRe } from '@/api/login';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { clearVuexStore } from '../../utils/utils';

const store = useStore();
const router = useRouter();

onMounted(() => {
  // 页面加载，先清空store缓存
  clearVuexStore(store);
  console.log('store', store);
});
/**
 * 登录成功事件
 */
const handleLogin = (data) => {
  loginRe(data).then((res) => {
    store.dispatch('user/login', res.data);
    router.push('/');
  });
};
</script>

<style lang="scss" scoped></style>
